module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm d-flex justify-content-center h-100 align-items-center"
  }, [_c('div', {
    staticClass: "ql-editor",
    staticStyle: {
      "height": "unset"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f51c9bc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/player/page/textcomponent.vue
// module id = 132
// module chunks = 0